module.exports = __webpack_public_path__ + "img/draw.890ab85b.svg";